import { render, staticRenderFns } from "./manage-traitement.html?vue&type=template&id=932568e2&scoped=true&external"
import script from "./manage-traitement.js?vue&type=script&lang=js&external"
export * from "./manage-traitement.js?vue&type=script&lang=js&external"
import style0 from "./manage-traitement.scss?vue&type=style&index=0&id=932568e2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932568e2",
  null
  
)

export default component.exports